import type { BotStatus } from './bot-detector'

export const TargetingMapping = {
    AD_BLOCK_STATUS: 'ab',
    IS_LOGGED_IN: 'l',
    BOT_STATUS: 'tst',
}

export type BotStatusTargeting = '0' | '1' | '2'

export const BOT_STATUS_TARGETING: Record<BotStatus, BotStatusTargeting> = {
    human: '0',
    bot: '1',
    unknown: '2',
}
